import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";

import type { GoogleFreeBookingLinksSettings } from "@/lib/gql/__generated__/graphql";

import { googleFreeBookingLinksSettingsInputZodSchema } from "./validation-schema";

import type { GoogleFreeBookingLinksSettingsZodSchemaType } from "./validation-schema";
import type { UseFormReturn } from "react-hook-form";

type Props = {
	googleFreeBookingLinksSettings: GoogleFreeBookingLinksSettings;
};

export const useGoogleFreeBookingLinksSettingsForm = ({
	googleFreeBookingLinksSettings,
}: Props): UseFormReturn<GoogleFreeBookingLinksSettingsZodSchemaType> => {
	const isNew = useMemo(
		() => googleFreeBookingLinksSettings.createdAt === googleFreeBookingLinksSettings.updatedAt,
		[googleFreeBookingLinksSettings],
	);

	const form: UseFormReturn<GoogleFreeBookingLinksSettingsZodSchemaType> =
		useForm<GoogleFreeBookingLinksSettingsZodSchemaType>({
			mode: "onChange",
			resolver: zodResolver(googleFreeBookingLinksSettingsInputZodSchema),
			defaultValues: {
				...googleFreeBookingLinksSettings,
				hotelType: isNew ? undefined : googleFreeBookingLinksSettings.hotelType, // ユーザーに選択させるために新規作成の場合はデフォルト値を設定しない
			},
		});

	// form 全体がメモ化される予定らしいので、`trigger` だけが `useEffect` の依存関係に含まれるようにしている
	// @docs https://react-hook-form.com/docs/useform#:~:text=useForm%20return%20and%20useEffect%20dependencies
	const { trigger } = form;
	useEffect(() => {
		trigger();
	}, [trigger]);

	return form;
};

export { googleFreeBookingLinksSettingsInputZodSchema } from "./validation-schema";
export type {
	GoogleFreeBookingLinksSettingsZodParseErrorType,
	GoogleFreeBookingLinksSettingsZodSchemaType,
} from "./validation-schema";
